// eslint-disable-next-line no-unused-vars
import React, { memo } from 'react';
import { node } from 'prop-types';
import { SWRConfig as DefaultSWRConfig } from 'swr';

import { getCacheProvider } from 'Providers/swr/swr';
import useFetch from 'Hooks/useFetch';

const SWRConfig = memo(({ children }) => {
  const fetcher = useFetch();
  return (
    <DefaultSWRConfig
      value={ {
        fetcher,
        revalidateOnMount: false,
        revalidateOnFocus: false,
        errorRetryCount: 3,
        provider: getCacheProvider,
        errorRetryInterval: 3500,
        onErrorRetry(err, key, config, revalidate, { retryCount }) {
          if (
            err.status === 404
            || err.status === 401
            || err.status === 403
            || retryCount >= config.errorRetryCount
          ) return;

          setTimeout(() => revalidate({ retryCount }), config.errorRetryInterval);
        }
      } }
    >
      { children }
    </DefaultSWRConfig>
  );
});

SWRConfig.propTypes = {
  children: node
};
SWRConfig.displayName = 'SWRConfigWrapper';

export default SWRConfig;
